import _import from '../_import'

export default [{
  path: '/login',
  name: 'login-view',
  component: _import('auth/LoginView'),
}, {
  path: '/register',
  name: 'register-view',
  component: _import('auth/RegisterView'),
}, {
  path: '/registration-agreement',
  name: 'registration-agreement',
  component: _import('auth/RegistrationAgreement'),
}, {
  path: '/reset',
  name: 'reset-view',
  component: _import('auth/ResetView'),
}]
